export const SET_WELCOME = "SET_WELCOME";